import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { AdminForm, AdminList } from "./";
import { ManagementLayout } from "@components/shared";

export default function AdminManagement() {
  const { t } = useTranslation();
  const [success, setSuccess] = useState(false);

  return (
    <ManagementLayout
      dataComponent={<AdminList />}
      createComponent={
        <Card>
          <Title order={4}>
            {t("create")} {t("admin_singular")}
          </Title>
          {!success && (
            <AdminForm
              onSuccess={() => {
                setSuccess(!success);
                setTimeout(() => {
                  setSuccess(false);
                }, 1);
              }}
            />
          )}
        </Card>
      }
    />
  );
}
